<template>
  <div>
    <router-view/>
  </div>
</template>
<script>

export default {
  components: {
    
  },
  setup() {
    
  },
}
</script>


<style>
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');

*{
  box-sizing: border-box;
}
body {
  font-family: "Lato", sans-serif;
  overscroll-behavior: none;
  margin: 0;
    padding: 0;
    height: 100vh;
    display: block;

}

html{
    overscroll-behavior: none;
    margin: 0;
    padding: 0;
    height: 100vh;
    display: block;
}




</style>
